module.exports = __webpack_public_path__ + "img/arbolado.9bf0c2d6.png";